import React, { useEffect } from "react";
import SaveIcon from "@mui/icons-material/SaveRounded";
import CloseIcon from "@mui/icons-material/CloseRounded";
import { Button, Modal, Col, Spinner } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import _ from "lodash";
import SwalMessage from "../_Components/SwalMessage";
import { FormControlLabel, Checkbox } from "@mui/material";
import Select from "react-select";
import ApiSupplierAgentCommission from "../../../core/api/api.supplierAgentCommission";
import SelectComponent from "../_Components/ReactSelectComponent";

const selectStyles = {
  menu: (base) => ({
    ...base,
    zIndex: 10000,
  }),
};

export const AssignCommissionGroupToSupplier = ({
  setShowAddCommissionToAgentModal,
  selectedAgentId,
  selectedCheckBoxes,
  allSupplierAgents,
  allCommissionGroups,
}) => {
  let handleClose = () => {
    setShowAddCommissionToAgentModal(false);
  };

  const isForGroupEdit = selectedAgentId === 0;
  let selectedSupplierAgnetsOrAgnet = isForGroupEdit
    ? allSupplierAgents?.data.filter((item) =>
        selectedCheckBoxes.includes(String(item.id))
      )
    : allSupplierAgents?.data.find(
        (item) => String(item.id) === selectedAgentId
      );
  selectedSupplierAgnetsOrAgnet =
    !isForGroupEdit && selectedSupplierAgnetsOrAgnet !== undefined
      ? [{ ...selectedSupplierAgnetsOrAgnet }]
      : selectedSupplierAgnetsOrAgnet;
  const {
    handleSubmit,
    control,
    formState: { isSubmitting },
    setValue,
  } = useForm({
    defaultValues: { isActive: true },
  });

  useEffect(() => {
    (async () => {
      try {
        if (!isForGroupEdit) {
          const response =
            await ApiSupplierAgentCommission.getSupplierAgentCommission({
              id: selectedAgentId,
            });
          if (response.succeeded) {
            const data = response.data;
            setValue("agentCommissionId", {
              label: data.agentCommissionName,
              value: data.agentCommissionId,
            });
            setValue("isActive", data.isActive);
          }
        }

        setValue(
          isForGroupEdit ? "supplierAgentCommissionIds" : "id",
          selectedSupplierAgnetsOrAgnet?.map((item) => ({
            value: item.id,
            label: item.agentCompanyName,
          }))
        );
      } catch (error) {
        console.log("error :>> ", error);
      }
    })();
  }, []);

  const onSubmit = async (data) => {
    try {
      let response;
      data.agentCommissionId = data.agentCommissionId.value;
      if (isForGroupEdit) {
        data.supplierAgentCommissionIds = [
          ...data.supplierAgentCommissionIds.map((item) => Number(item.value)),
        ];
        delete data.isActive;
        response =
          await ApiSupplierAgentCommission.editSupplierAgentCommissionInGroup(
            data
          );
      } else {
        data.id = +selectedAgentId;
        response =
          await ApiSupplierAgentCommission.editSupplierAgentCommission(data);
      }
      SwalMessage({
        title: response.message,
        iSsuccess: response.succeeded,
        timer: 5000,
      });
      if (response.succeeded) {
        handleClose();
        document.getElementById("submitButton").click();
      }
    } catch (error) {
      console.log("error =>", error);
    }
  };
  return (
    <div>
      <Modal centered size="md" show={true} onHide={handleClose}>
        <form id="form" onSubmit={handleSubmit(onSubmit)}>
          <Modal.Header closeButton>
            <Modal.Title>{`${isForGroupEdit ? "تخصیص گروه کمیسیون به نمایندگان" : "ویرایش تخصیص گروه کمیسیون به نمایندگان"}`}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Col xs="12">
              <Controller
                name={isForGroupEdit ? "supplierAgentCommissionIds" : "id"}
                control={control}
                render={({ field }) => (
                  <SelectComponent
                    className="mt-0 mb-5"
                    placeholder=" نماینده"
                    options={allSupplierAgents?.data?.map((item) => ({
                      value: item.agentId,
                      label: item.agentCompanyName,
                    }))}
                    defaultValue={
                      isForGroupEdit
                        ? selectedSupplierAgnetsOrAgnet?.map((item) => ({
                            value: item.id,
                            label: item.agentCompanyName,
                          }))
                        : []
                    }
                    field={field}
                    isMulti={isForGroupEdit}
                    isDisabled={!isForGroupEdit}
                  />
                  // <Select
                  //   closeMenuOnSelect={false}
                  //   styles={selectStyles}
                  //   inputId="react-select-multiple"
                  //   TextFieldProps={{
                  //     label: "Countries",
                  //     InputLabelProps: {
                  //       htmlFor: "react-select-multiple",
                  //       shrink: true,
                  //     },
                  //     placeholder: "Select multiple countries",
                  //   }}
                  //   options={allSupplierAgents?.data?.map((item) => ({
                  //     value: item.id,
                  //     label: item.agentCompanyName,
                  //   }))}
                  //   defaultValue={
                  //     isForGroupEdit
                  //       ? selectedSupplierAgnetsOrAgnet?.map((item) => ({
                  //           value: item.id,
                  //           label: item.agentCompanyName,
                  //         }))
                  //       : []
                  //   }
                  //   value={value || ""}
                  //   onChange={onChange}
                  //   placeholder=" نماینده ها"
                  //   isMulti={isForGroupEdit}
                  //   isDisabled={!isForGroupEdit}
                  // />
                )}
              />
            </Col>
            <Col xs="12" className="mt-3">
              <Controller
                name="agentCommissionId"
                control={control}
                rules={{}}
                render={({ field }) => (
                  <SelectComponent
                    className="mt-0 mb-5"
                    placeholder=" گروه کمیسیون"
                    options={allCommissionGroups?.map((item) => ({
                      value: item.id,
                      label: item.name,
                    }))}
                    field={field}
                  />
                  // <Select
                  //   styles={selectStyles}
                  //   inputId="react-select-multiple"
                  //   TextFieldProps={{
                  //     label: "Countries",
                  //     InputLabelProps: {
                  //       htmlFor: "react-select-multiple",
                  //       shrink: true,
                  //     },
                  //     placeholder: "Select multiple countries",
                  //   }}
                  //   options={allCommissionGroups?.map((item) => ({
                  //     value: item.id,
                  //     label: item.name,
                  //   }))}
                  //   value={value || ""}
                  //   onChange={onChange}
                  //   placeholder=" گروه کمیسیون"
                  // />
                )}
              />
            </Col>
            {!isForGroupEdit && (
              <Col xs="12">
                <FormControlLabel
                  control={
                    <Controller
                      control={control}
                      name={"isActive"}
                      render={({
                        field: { onChange, onBlur, value, name, ref },
                        fieldState: { invalid, isTouched, isDirty, error },
                      }) => (
                        <Checkbox
                          color="primary"
                          onBlur={onBlur}
                          onChange={onChange}
                          checked={value || false}
                          inputRef={ref}
                        />
                      )}
                    />
                  }
                  label="فعال"
                />
              </Col>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="success" type="submit" disabled={isSubmitting}>
              {isSubmitting && (
                <Spinner animation="border" variant="warning" size="sm" />
              )}
              <SaveIcon /> ذخیره
            </Button>
            <Button variant="danger" onClick={handleClose}>
              <CloseIcon /> بستن
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    </div>
  );
};
